import { createSlice } from "@reduxjs/toolkit";
import savedCollectionsReducer from "@/components/SavedCollectionsListing/redux/reducers";
import savedCollectionsInitialState from "@/components/SavedCollectionsListing/redux/initialState";

const collectionsSlice = createSlice({
  name: "savedCollections",
  initialState: savedCollectionsInitialState,
  reducers: savedCollectionsReducer,
});

export const { setLoading, setError, setSavedArticles, setSavedVideos, setCurrentCollection } =
  collectionsSlice.actions;

export default collectionsSlice.reducer;
